/**
 * The earliest date for which metrics data is available for Airline Portal.
 * Users cannot select dates before this date in the date picker.
 *
 * @remarks
 * This date is subject to change once the actual data availability date is confirmed.
 * Update this constant when the confirmed date is determined.
 */
export const CAMPAIGN_PERFORMANCE_METRICS_AVAILABLE_DATE = new Date("2026-01-01");

export const DEFAULT_CAMPAIGN = "GENIUS_AIRLINE_FARE";
